import { render, staticRenderFns } from "./NewsFeatures.vue?vue&type=template&id=818fbeac"
import script from "./NewsFeatures.js?vue&type=script&lang=js&external"
export * from "./NewsFeatures.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports